import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-22 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={aiDigitalData.about.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {aiDigitalData.about.title}
          </h2>
          <div className="space-y-3">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-bold">
              {aiDigitalData.about.description}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aiDigitalData.about.description2}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aiDigitalData.about.description3}
            </p>
          </div>
        </div>

        {/* Comparison: Two flows */}
        <div className="reveal grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {/* Tool First */}
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-7">
            <div className="flex items-center gap-2.5 mb-4 md:mb-5">
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-shopping-cart-2-line text-secondary-600" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {aiDigitalData.about.toolFirst.title}
              </h3>
            </div>
            <div className="space-y-0">
              {aiDigitalData.about.toolFirst.steps.map((step, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="flex flex-col items-center">
                    <div className="w-7 h-7 rounded-full bg-secondary-50 border border-secondary-200 flex items-center justify-center text-xs font-bold text-secondary-600 font-label flex-shrink-0">
                      {i + 1}
                    </div>
                    {i < aiDigitalData.about.toolFirst.steps.length - 1 && (
                      <div className="w-px h-5 bg-secondary-200" />
                    )}
                  </div>
                  <span className="text-sm md:text-base text-foreground-600 py-1.5">
                    {step}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Noble Labo Way */}
          <div className="rounded-lg bg-primary-50/60 border border-primary-200/60 p-6 md:p-7">
            <div className="flex items-center gap-2.5 mb-4 md:mb-5">
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-star-line text-background-50" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {aiDigitalData.about.nobleWay.title}
              </h3>
            </div>
            <div className="space-y-0">
              {aiDigitalData.about.nobleWay.steps.map((step, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="flex flex-col items-center">
                    <div className="w-7 h-7 rounded-full bg-primary-500/15 border border-primary-300 flex items-center justify-center text-xs font-bold text-primary-700 font-label flex-shrink-0">
                      {i + 1}
                    </div>
                    {i < aiDigitalData.about.nobleWay.steps.length - 1 && (
                      <div className="w-px h-5 bg-primary-200" />
                    )}
                  </div>
                  <span className="text-sm md:text-base text-foreground-700 py-1.5">
                    {step}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}